import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { sendWelcomeEmail } from '../utils/sendEmail';
import './AuthCallback.css';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handle() {
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        if (sessionError || !session?.user) {
          navigate('/login?error=oauth_failed', { replace: true });
          return;
        }

        const user = session.user;
        const meta = user.user_metadata || {};

        const { data: existing } = await supabase
          .from('profiles')
          .select('id')
          .eq('id', user.id)
          .maybeSingle();

        if (!existing) {
          const nameParts = (meta.name || meta.full_name || '').trim().split(/\s+/);
          const firstName = meta.first_name || meta.given_name || nameParts[0] || '';
          const lastName  = meta.last_name  || meta.family_name || nameParts.slice(1).join(' ') || '';
          const fullName  = meta.full_name || meta.name || `${firstName} ${lastName}`.trim() || null;
          const avatarUrl = meta.picture || meta.avatar_url || null;
          const phone     = meta.phone || '';

          const { error: insertErr } = await supabase.from('profiles').insert({
            id:         user.id,
            email:      user.email || null,
            first_name: firstName,
            last_name:  lastName,
            full_name:  fullName,
            avatar_url: avatarUrl,
            phone,
            is_pro:     false,
          });
          if (insertErr) console.error('AuthCallback: profile insert failed', insertErr);

          // First-time welcome email — fire-and-forget, never block sign-in
          try {
            await sendWelcomeEmail({ firstName, email: user.email, userId: user.id });
          } catch (e) {
            console.error('AuthCallback: welcome email failed', e);
          }
        }

        const redirectTo = sessionStorage.getItem('postLoginRedirect') || '/';
        sessionStorage.removeItem('postLoginRedirect');
        navigate(redirectTo, { replace: true });
      } catch (err) {
        console.error('AuthCallback error:', err);
        navigate('/login?error=callback_failed', { replace: true });
      }
    }
    handle();
  }, [navigate]);

  return (
    <div className="authCallback">
      <div className="authCallback__card">
        <div className="authCallback__spinner" />
        <h2 className="authCallback__title">Signing you in…</h2>
        <p className="authCallback__subtitle">This will just take a moment.</p>
      </div>
    </div>
  );
}
